export default __webpack_public_path__ + "static/media/sklad.5bdec544.svg";